import Vue from "vue";
import './plugins/axios'
import App from "./App.vue";
import Router from 'vue-router';
import router from "./router/index";
import store from "./store/index";
import './plugins/element.js';
import './plugins/amap.js';
import './plugins/echarts.js';
import './plugins/clipboard.js';
import {
	getToken,
	getInfo
} from './utils/token';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import './styles/iconfont.css';
import './styles/base.css';
import './styles/common.css';
import './utils/prototype';
import components from './components';
import VuePrototype from './utils/vue-prototype';
import getPageTitle from './utils/get-page-title';
import signalr from './utils/signalR';
import './filters';

Vue.config.productionTip = false;
Vue.use(VuePrototype);
Vue.use(signalr);

//解决：vue-router路由版本更新产生的问题,导致路由跳转失败抛出该错误，但并不影响程序功能
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}

//路由跳转拦截器
router.beforeEach((to, from, next) => {
	// console.log(to)
	setTimeout(() => {
		V.$store.dispatch("menu/InitMenuIndex", to.path);
	}, 0);
	//如果不是登录页，判断权限
	if (to.name != "login") {
		if (getToken() == undefined) {
			if (from.name != 'login') {
				NProgress.start();
				next({
					path: '/login',
					query: {
						redirect: to.fullPath
					}
				})
			}
		} else {
			document.title = getPageTitle(to.meta.title)
			if (to.meta.content) {
				let head = document.getElementsByTagName('head');
				let meta = document.createElement('meta');
				document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content
					.keywords)
				document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content
					.description)
				meta.content = to.meta.content;
				head[0].appendChild(meta)
			}
			NProgress.start();
			next()
		}
	} else {
		document.title = getPageTitle(to.meta.title)
		if (to.meta.content) {
			let head = document.getElementsByTagName('head');
			let meta = document.createElement('meta');
			document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
			document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content
				.description)
			meta.content = to.meta.content;
			head[0].appendChild(meta)
		}
		NProgress.start();
		next()
	}
})
router.afterEach((to, from) => {
	if (from.name != "login" && to.name == "login") {
		//清除通知
		V.$notify.closeAll();
	}
	// V.$store.dispatch("menu/InitMenuIndex");


	NProgress.done()
})

// 进度条的配置项：ease可以设置css3动画，如ease，linear；speed是进度条从开始到结束的耗时
NProgress.configure({
	ease: 'linear',
	speed: 500,
	showSpinner: false
});

Vue.use(components);

window.V = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
